<section class="services-process-section dingo-section dingo-bg-base">
  <div class="container">
    <div class="services-process-layout">
      <div class="services-process-copy section-head reveal-on-scroll" data-reveal="section-head">
        <p class="services-kicker">Cómo trabajamos</p>
        <h2 class="services-section-title">
          Del diagnóstico a la <span class="highlight-green">optimización continua</span>
        </h2>
        <p class="services-section-desc services-section-desc--left">
          Cada servicio forma parte de un sistema orientado a crecimiento medible y mejora constante.
        </p>
      </div>
      <div class="services-process-list">
        @for (step of processSteps; track step.title; let i = $index) {
        <article class="services-process-card reveal-on-scroll" data-reveal="card" [style.--reveal-order]="i">
          <span>0{{ i + 1 }}</span>
          <i class="bi {{ step.icon }}"></i>
          <div>
            <h3>{{ step.title }}</h3>
            <p>{{ step.description }}</p>
          </div>
        </article>
        }
      </div>
    </div>
  </div>
</section>
